import BigNumber from 'bignumber.js';
import { useCallback } from 'react';

import { MiningCallbacks } from './common/callbacks';
import { isGasToken } from '../../../../config/tokens';
import { parseJsonRpcError } from '../../../../utils/funcs';
import { buildSendingParams } from '../../../../utils/contractHelpers';
import { useWeb3WithDefault } from '../../../../hooks/useWeb3WithDefault';
import { ChainId, FarmDynamicRangeiZiContractVersion } from '../../../../types/mod';
import { useMiningDynamicRangeiZiContractWithVersion } from '../../../../hooks/useContracts';
import { PoolEntryState } from '../../farm/iZiSwap/dynamicRange/types';

export interface DynamicRangeiZiDepositParams {
    amount0Desired: string;
    amount1Desired: string;
    numIZI: string;
}

export interface DynamicRangeiZiEntity {
    deposit: (params: DynamicRangeiZiDepositParams, callbacks: MiningCallbacks, gasPrice: number) => void;
}

export interface MintCallParams {
    chainId: ChainId;
    account: any;
    poolEntry: PoolEntryState;
    miningContract: any;
    gas?: string;
    gasPrice?: number;
    depositParams: DynamicRangeiZiDepositParams;
}

const _getMintCallV2 = (params: MintCallParams): any => {
    const { account, poolEntry, miningContract, gas, gasPrice, depositParams, chainId } = params;
    let sendValue = '0';
    if (isGasToken(poolEntry.meta.tokenA, chainId)) {
        sendValue = depositParams.amount0Desired;
    }
    if (isGasToken(poolEntry.meta.tokenB, chainId)) {
        sendValue = depositParams.amount1Desired;
    }
    const options = {
        from: account,
        value: sendValue,
        gas: gas,
        maxFeePerGas: gasPrice,
    };

    console.log('+++++++++++++++++++: ',
        depositParams.amount0Desired,
        depositParams.amount1Desired,
        depositParams.numIZI,
        poolEntry.data.oracleTick)

    return [miningContract?.methods.deposit(
        depositParams.amount0Desired,
        depositParams.amount1Desired,
        depositParams.numIZI,
        poolEntry.data.oracleTick
    ), options];
};


const _getMintCallVeiZi = (params: MintCallParams): any => {
    const { account, poolEntry, miningContract, gas, gasPrice, depositParams, chainId } = params;
    let sendValue = '0';
    if (isGasToken(poolEntry.meta.tokenA, chainId)) {
        sendValue = depositParams.amount0Desired;
    }
    if (isGasToken(poolEntry.meta.tokenB, chainId)) {
        sendValue = depositParams.amount1Desired;
    }
    const options = {
        from: account,
        value: sendValue,
        gas: gas,
        maxFeePerGas: gasPrice,
    };

    return [miningContract?.methods.deposit(
        depositParams.amount0Desired,
        depositParams.amount1Desired,
        poolEntry.data.oracleTick
    ), options];
};

const useDynamicRangeiZiEntity = (poolEntry: PoolEntryState): DynamicRangeiZiEntity => {
    const { chainId, account } = useWeb3WithDefault();

    const { contract } = useMiningDynamicRangeiZiContractWithVersion(poolEntry.meta.miningContract, poolEntry.meta.contractVersion);

    const version = poolEntry.meta.contractVersion;

    const deposit = useCallback(
        (params: DynamicRangeiZiDepositParams, callbacks: MiningCallbacks, gasPrice: number) => {

            let getMintCall = _getMintCallV2;

            if (version === FarmDynamicRangeiZiContractVersion.VEIZI) {
                getMintCall = _getMintCallVeiZi;
            }
            const [mintCall, options] = getMintCall(
                {
                    chainId, account, poolEntry, miningContract: contract, depositParams: params
                }
            );

            mintCall.estimateGas(buildSendingParams(chainId, options, gasPrice))
                .then((gas: number) => {
                    const gasLimit = new BigNumber(gas * 1.1).toFixed(0, 2);

                    const [sendMintCall, sendOptions] = getMintCall(
                        {
                            chainId, account, poolEntry, miningContract: contract, depositParams: params, gas: gasLimit, gasPrice
                        }
                    );
                    sendMintCall.send(buildSendingParams(chainId, sendOptions, gasPrice))
                        .on('transactionHash', (e: any) => { callbacks.onTransactionHash?.(e); })
                        .then((e: any) => { callbacks.then?.(e); })
                        .catch((e: any) => { callbacks.catch?.(e); });
                })
                .catch((e: any) => { callbacks.catch?.(parseJsonRpcError(e)); });
        },
        [chainId, version, account, poolEntry, contract]
    );
    return {
        deposit
    };
};

export default useDynamicRangeiZiEntity;